import { render, staticRenderFns } from "./salesQuery2Csr.vue?vue&type=template&id=b1643ff2&"
import script from "./salesQuery2Csr.vue?vue&type=script&lang=js&"
export * from "./salesQuery2Csr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1643ff2')) {
      api.createRecord('b1643ff2', component.options)
    } else {
      api.reload('b1643ff2', component.options)
    }
    module.hot.accept("./salesQuery2Csr.vue?vue&type=template&id=b1643ff2&", function () {
      api.rerender('b1643ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/salesQuery2Csr.vue"
export default component.exports